/**
 * @file   src\Pages\Promotions.tsx
 * @brief  Promotions page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Link, useParams, useState , useNavigate, useEffect} from "../utils/thirdpartyComponents"
import Gobackicon from "../assets/images/left-arrow-small.svg";
import CWFooter from "src/components/CWFooter";
import "src/styles/inner-page-styles.scss";
import { pageURLs } from "src/utils/pageUrls";
import PromotionDetail from "src/components/PromotionDetail";
import { ISubscriptionandsinglewash, ISubscriptionarray, ISingleWasharray, ActiveSubscriptionarray } from '../interfaces/generalInterface';
import axios from '../config/axiosConfig';
import { SubscriptionandwashpriceApi , PromotionApi} from "../utils/apiUrls";
import SmallLoader from "src/components/SmallLoader";
import { MessageToaster } from "src/utils/toastUtil";
import { BuyType } from "src/utils/enums";

const Promotions = () => {
    // Route information variable
    const params = useParams();
     const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search);
      const [listLoading, setListLoading] = useState(false);
    const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
    const [activeSubscription, setActiveSubscription] = useState(0);
    const [selectedSubscription, setSelectedSubscription] = useState<ISubscriptionarray>();
    const [buyfromtab, setBuyfromtab] = useState('');
    const [updateConfirmationMessage, setupdateConfirmationMessage] = useState('Your subscription will switch to the new plan after your current plan expires. Are you sure you want to change your subscription now?');
    const [activeSubscriptionData, setActiveSubscriptionData] = useState<ActiveSubscriptionarray>();
    const [showTrailPeriodConsumptionModal, setTrailPeriodConsumptionModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const showSingleWash = queryParams.get('showSingleWash') === 'true';
    const hasQueryParams = location.search !== '';
    const scanAction = (queryParams.get('scan') === 'true') ? true : false;
    const washType = (queryParams.get('washType') === 1 || queryParams.get('washType') === 2) ? queryParams.get('washType') : 0;
  
   

    // State to handle list of promotions
    const [promotions, setPromotions] = useState([]);

      useEffect(() => {
        localStorage.removeItem('subscriptionID')
        fetchPromotions();
    
      }, []);

    //buy now click function
      const buynowClick = async (subscription: ISubscriptionarray, buyfrom: string) => {
        setBuyfromtab(buyfrom);
        //if active subscription show confrmation modal
        if (activeSubscription && buyfrom === 'subscriptions') {
          if (activeSubscriptionData && activeSubscriptionData?.IsCancelled == 0 && activeSubscriptionData?.numberOfWashes === 0) {
            setupdateConfirmationMessage("Your active subscription has no wash remaining. Your subscription will switch to the new plan. Are you sure you want to change to the new subscription now?")
          } else if (activeSubscriptionData && activeSubscriptionData?.price < subscription.price) {
            setupdateConfirmationMessage("You are upgrading your subscription. Your subscription will switch to the new plan immediately. Are you sure you want to change to the new subscription now?")
          } else if (activeSubscriptionData && activeSubscriptionData?.price > subscription.price) {
            setupdateConfirmationMessage("You are going to downgrade your subscription. Your subscription will switch to the new plan after your current plan expires. Are you sure you want to change your subscription now?")
          }
          setSelectedSubscription(subscription)
          setShowUpdateConfirmation(true)
        }
    
        else {
            console.log(subscription)
          if (subscription.isTrial) {
            setLoading(true)
            const responseSubscriptions = await axios.get(SubscriptionandwashpriceApi.TRAIL_CONSUMPTION_CHECKING + '/' + subscription.subscriptionID);
            if (responseSubscriptions?.data?.error === 0 && responseSubscriptions?.data?.data?.isConsumed === 1) {
              setLoading(false)
              setSelectedSubscription(subscription)
              setTrailPeriodConsumptionModal(true)
            } else {
              setLoading(false)
              onBuy(subscription, buyfrom);
            }
          } else {
            onBuy(subscription, buyfrom);
          }
    
        }
      }

      //redirection to payment
    const onBuy = (subscription: ISubscriptionarray, buyfrom: string) => {
        const fromTab = buyfrom;
        navigate("/" + params.carwashname + "/" + pageURLs.payment + "?scan=" + scanAction + "&washType=" + washType, { state: { origin: 'WashSelection', fromTab: fromTab, subscriptionID: subscription.subscriptionID, washName: subscription.washName, price: subscription.price, numberOfWashes: subscription.numberOfWashes, subscriptionType: subscription.subscriptionType, isTrial: subscription.isTrial, trialPeriod: subscription.trialPeriod, trialAmount: subscription.trialAmount } })
    };

    const fetchPromotions = async () => {
         const toaster = new MessageToaster();
        setListLoading(true)
        try {

            const responsePromotions = await axios.get(PromotionApi.PROMOTION_LIST);
            if (responsePromotions?.data?.error === 0) {
                setPromotions(responsePromotions?.data?.data);
           
            } else {
                toaster.toastError(responsePromotions?.data?.message);
            }
            setListLoading(false)
        }
        catch (error : any) {
            throw new Error(error?.response?.data?.message || error?.message);
        }
    }
    

    return (

        <div className="common-content-wrap pb-80">
            <div className="inner-content-wrap">
                <div className="common-header two-block-header">
                    <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                        <div className="common-header-inner">
                            <Link to={"/"+params.carwashname+"/"+pageURLs.settings} className="back-link"><img src={Gobackicon} alt="Car Wash App" /></Link> Promotions
                        </div>
                    </div>
                </div>
                <div className="main-content-wrap pe-0 ps-0 pt-0">
                    <div className="my-subscription-wrap">

                        {(promotions && promotions.length) ? promotions.map((promotion,index) => (
                            <PromotionDetail 
                            key={index} 
                            name={promotion.promotionName} 
                            description={promotion.promotionDetails} 
                            promocode={promotion.promotionCode} 
                            validity={promotion.validTo} 
                            washName = {promotion.washName}  
                            buyType={BuyType.SUBSCRIPTION}
                                              
                            setShowUpdateConfirmation={setShowUpdateConfirmation}
                            promotion={promotion}
                            onBuynowClick={(promotion: ISubscriptionarray) => buynowClick(promotion, 'subscriptions')}    
                        />
                        )) : ' No data found'}

                    </div>
                </div>
            </div>
            {loading ? <SmallLoader /> : ""}
            <CWFooter activeLink="Settings"/>
        </div>
    )
}

export default Promotions;
